import { useState, useEffect, useRef } from "react";
import $ from "jquery";
import cx from "classnames";
import { startOfYear, startOfMonth, endOfMonth, sub, add, format, parseISO, differenceInBusinessDays, endOfYear } from "date-fns";
import axios from "axios";
import { endpoint } from "./config";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";


function Reports() {
  const startDate = startOfYear(new Date());
  const yearEndDate = endOfYear(new Date());
  const [monthRange] = useState([
    sub(startDate, { months: 3 }),
    sub(startDate, { months: 2 }),
    sub(startDate, { months: 1 }),
    startDate,
    add(startDate, { months: 1 }),
    add(startDate, { months: 2 }),
    add(startDate, { months: 3 }),
    add(startDate, { months: 4 }),
    add(startDate, { months: 5 }),
    add(startDate, { months: 6 }),
    add(startDate, { months: 7 }),
    add(startDate, { months: 8 }),
    add(startDate, { months: 9 }),
    add(startDate, { months: 10 }),
    yearEndDate,
  ]);

  const [reportType, setReportType] = useState("By Month");
  const [employees, setEmployees] = useState(null);
  const [rawData, setRawData] = useState(null);
  const [detailsData, setDetailsData] = useState([]);

  const [xAxis, setXAxis] = useState([]);
  const [series, setSeries] = useState([]);

  const [filter, setFilter] = useState({employeeName:"", employeeId: "", manager: "", project: ""});
  const tableDetails = useRef(null);

  const mountedRef = useRef();


  function changeType(event) {
    setReportType($(event.target).html());
    //console.log($(event.target).html());
  }

  useEffect(() => {
    async function asynFn(){
      const [tempEmployees] = await axios.all([fetchEmployee()]);
      //console.log(tempRawData);
      setEmployees(tempEmployees);
    }
    if (mountedRef.current) asynFn();
  }, [filter]);

  useEffect(() => {
      console.log("rendered")
      mountedRef.current = true;

      async function asynFn(){
        //await axios.all(fetchEmployee(), fetchDetailedReport());
      }
      asynFn();
  }, []);

  useEffect( ()=>{
    async function asynFn(){
      const [tempEmployees, tempRawData] = await axios.all([fetchEmployee(), fetchDetailedReport()]);
      console.log(tempRawData);
      setEmployees(tempEmployees);
      setRawData(tempRawData);
    }
    asynFn();
    
  }, [reportType]);

  const fetchEmployee = async () => {
    try{
      const response = await axios.get(
        `${endpoint}/employees?employeeName=${filter.employeeName || ""}&employeeId=${filter.employeeId || ""}&project=${
          filter.project || ""
        }&manager=${filter.manager || ""}`
      );
      return response.data.data;
    }catch(err){
      console.log('getEmployee', err.message);
    }
    /*
    const response = await axios.get(
      `${endpoint}/employees?employeeName=${filter.employeeName || ""}&employeeId=${filter.employeeId || ""}&project=${
        filter.project || ""
      }&manager=${filter.manager || ""}`
    );
    const data = response.data;
    //console.log(data);
    if (data.status) {
      const emp = data.data;
      setEmployees(emp);
      //console.log(emp);
    } else {
      //toast("Please login with correct Employee Account.");
      console.log(data.message);
    }*/
  }
  const fetchDetailedReport = async ()=> {
    try{
      const response = await axios.get(
        `${endpoint}/detailedReport/${format(sub(startDate, { months: 3 }), "yyyy-MM-dd")}/${format(endOfYear(
          add(startDate, { months: 11 })),
          "yyyy-MM-dd"
        )}`
      );
      return response.data.data;

    }catch(err){
      console.log('getDetailedReport', err.message);
    }
    /*
    const response = await axios.get(
      `${endpoint}/detailedReport/${format(sub(startDate, { months: 3 }), "yyyy-MM-dd")}/${format(
        add(startDate, { months: 11 }),
        "yyyy-MM-dd"
      )}`
    );
    const data = response.data;
    //console.log(data);
    if (data.status) {
      const rows = data.data;
      //setEmployees(emp);
      setRawData(rows);

      //console.log(getMonthValue(1, "01-2023"));
      //console.log(rows);
    } else {
      //toast("Please login with correct Employee Account.");
      console.log(data.message);
    }*/
  }
  const getMonthValue = (empId, monthVal) => {
    //console.log(empId, monthVal);
    return rawData.find((row) => row.employeeId === empId && row.monthName === monthVal);
  };

  const getTotalHours = (monthVal, field) => {
    //console.log(empId, monthVal);
    //let sum;
    //month = rawData.find((row) => {if (row.monthName === monthVal){ sum += row.claimedHours}} );
    let sum = 0;
    rawData.forEach((row) => {
      if (row.monthName === monthVal) {
        //console.log("matched", row);
        sum += parseInt(row[field]);
      }
    });
    return sum;
  };
  const getActiveEmployees = (date) => {
    //console.log(empId, monthVal);
    let startDate = startOfMonth(date);
    startDate.setHours(0, 0, 0, 0);
    let endDate = endOfMonth(date);
    endDate.setHours(0, 0, 0, 0);

    return employees.filter((row) => {
      let billingStartDate = new Date(row.billingStartDate);
      billingStartDate.setHours(0, 0, 0, 0);

      let billingEndDate = new Date(row.billingEndDate);
      billingEndDate.setHours(0, 0, 0, 0);

      //console.log(format(startDate, "dd/MM/yyyy"), format(endDate, "dd/MM/yyyy"), format(billingStartDate, "dd/MM/yyyy"), format(billingEndDate, "dd/MM/yyyy"));
      //console.log(new Date(row.billingStartDate) <= startDate, new Date(row.billingEndDate) >= startDate);
      //console.log((billingStartDate <= startDate || billingStartDate >= endDate), (billingEndDate >= startDate || billingEndDate >= endDate));
      //return (billingStartDate >= startDate && billingStartDate <= endDate) || billingStartDate <= startDate;
      return row.status===1 && ((billingStartDate >= startDate && billingStartDate <= endDate) || billingStartDate <= startDate) && (billingEndDate>=startDate);
      //return (billingStartDate <= startDate || billingStartDate >= endDate) && (billingEndDate >= startDate || billingEndDate >= endDate);
    });
  };

  useEffect(() => {
    if (employees) {
      let tempArray = [];
      employees.forEach((element) => {
        monthRange.forEach((val) => {
          const monthValue = getMonthValue(element.employeeId, format(val, "MM-yyyy"));
          const formatted = format(val, "MM-yyyy");
          if (monthValue) {
            element["submittedHours" + formatted] = monthValue.submittedHours;
            element["approvedHours" + formatted] = monthValue.approvedHours;
          } else {
            element["submittedHours" + formatted] = "";
            element["approvedHours" + formatted] = "";
          }
        });
        //console.log(element);

        tempArray.push(element);
      });
      //console.log(tempArray);

      setDetailsData(tempArray);
    }
  }, [employees, rawData]);

  useEffect(() => {
    //console.log(getMonthValue(1, "01-2023"));

    if (rawData) {
      console.log("changed", rawData);
      let tempArray = [];
      let forecastArray = [];
      let claimedArray = [];
      let approvedArray = [];
      let rejectedArray = [];

      monthRange.forEach((val) => {
        const formatted2 = format(val, "MMM yy");
        tempArray.push(formatted2);

        const formatted = format(val, "MM-yyyy");
        claimedArray.push(getTotalHours(formatted, "submittedHours"));
        approvedArray.push(getTotalHours(formatted, "approvedHours"));
        rejectedArray.push(getTotalHours(formatted, "submittedHours") - getTotalHours(formatted, "approvedHours"));

        const activeEmployee = getActiveEmployees(val);
        const employeeCount = (activeEmployee) ? activeEmployee.length:0;
        let workingDays = differenceInBusinessDays(endOfMonth(val), startOfMonth(val))+1;
        //console.log('working days', workingDays);
        forecastArray.push(employeeCount * workingDays * 8);
        console.log("No. of Employee", formatted, activeEmployee && activeEmployee.length, "working days", workingDays, activeEmployee);
      });
      setXAxis(tempArray);

      let tempSeries = [];

      tempSeries.push(
        {
          name: "Forecast hours",
          data: forecastArray,
          stack: "Forecast",
          pointPadding: "-0.2",
          color: "#c9c9c9",
        },
        {
          name: "Claimed hours",
          data: claimedArray,
          stack: "Claimed hours",
          pointPadding: "-0.2",
          color: "#00b6ce",
        },
        {
          name: "Rejected hours",
          data: rejectedArray,
          stack: "Claimed",
          pointPadding: "-0.2",
          color: "#ff7a7a",
        },
        {
          name: "Approved hours",
          data: approvedArray,
          stack: "Claimed",
          pointPadding: "-0.2",
          color: "#8fd14f",
        }
      );

      setSeries(tempSeries);
    }

    //console.log(getTotalHours("02-2023", "submittedHours"), getTotalHours("02-2023", "approvedHours"));
  }, [rawData]);

  const generateKey = (pre) => {
    return `${pre}_${new Date().getTime()}`;
  };

  function exportExcel() {
    //console.log($('#tableDetails').html());
    let tableData = $("#tableDetails").html();
    var fileDownload = require("js-file-download");
    let document = `<html><head><style>
    .text-center {
      text-align: center !important;
    }
    .text-muted{
      color: #999999;
    }
    .text-submitted{
      text-align: center !important;
      color: #999999;
    }
    </style></head> 
    <body>${tableData}</body></html>`;
    console.log(document);
    fileDownload(document, "TTMS Report - Details.xls");
  }

  function handleChange(event) {
    setFilter({ ...filter, [event.target.name]: event.target.value });
    //console.log(event.target.name);
  }

  return (
    <>
      <header className="page-title-bar">
        <h1 className="page-title mr-sm-auto mb-0"> Timesheet Report </h1>
      </header>
      <div className="flex justify-center align-center mb-3">
        <div className="btn-group">
          <button
            type="button"
            className={cx("btn btn-secondary mr-1", reportType === "By Month" && "active")}
            onClick={changeType}
          >
            By Month
          </button>
          <button
            type="button"
            className={cx("btn btn-secondary mr-1", reportType === "By Week" && "active")}
            onClick={changeType}
          >
            By Week
          </button>
          <button
            type="button"
            className={cx("btn btn-secondary", reportType === "Details" && "active")}
            onClick={changeType}
          >
            Details
          </button>
        </div>
      </div>
      <div className="card" style={{ marginBottom: "60px" }}>
        <div className="card-body">
          {reportType === "By Month" && (
            <HighchartsReact
              highcharts={Highcharts}
              options={{
                chart: {
                  zoomType: "xy",
                  type: "column",
                },
                title: {
                  text: "",
                },
                subtitle: {
                  //text: 'Weekly temperature averages'
                },
                tooltip: {
                  //shared: true,
                },

                xAxis: {
                  categories: xAxis,
                  title:{
                    text: "Month"
                  }
                },

                yAxis: {
                  allowDecimals: false,
                  min: 0,
                  title: {
                    text: "Hours",
                  },
                },

                plotOptions: {
                  series: {
                    //grouping: false,
                    //borderWidth: 0,
                    
                },
                
                  column: {
                    stacking: "normal",
                  },
                },
                legend: {
                  layout: 'vertical',
                  align: 'right',
                  verticalAlign: 'top',
                  floating: true
                },
                credits:{
                  enabled: false
                },
                series: series,
                /*
                series: [
                  {
                    name: "Forecast hours",
                    data: [0, 0, 0, 144, 133, 124, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    stack: "Forecast",
                  },
                  {
                    name: "Claimed hours",
                    data: [0, 0, 0, 144, 98, 65],
                    stack: "Claimed hours",
                  },
                  {
                    name: "Rejected hours",
                    data: [0, 0, 0, 10, 122, 95],
                    stack: "Claimed",
                  },
                  {
                    name: "Approved hours",
                    data: [0, 0, 0, 120, 72, 80],
                    stack: "Claimed",
                  },
                ],*/

                // options - see https://api.highcharts.com/highcharts
              }}
            />
          )}
          {reportType === "Details" && (
            <>
              <h5 className="mt-0 mb-2">Filter</h5>
              <div className="flex justify-between mb-3">
                <div className="flex gap-1">
                  <input
                    type={"text"}
                    className="form-control wd-150"
                    placeholder="Emp Name"
                    name="employeeName"
                    onChange={handleChange}
                    value={filter.employeeName || ""}
                  ></input>
                  <input
                    type={"text"}
                    className="form-control wd-100"
                    placeholder="Emp ID"
                    name="employeeId"
                    onChange={handleChange}
                    value={filter.employeeId || ""}
                  ></input>
                  <input
                    type={"text"}
                    className="form-control wd-150"
                    placeholder="Manager"
                    name="manager"
                    onChange={handleChange}
                    value={filter.manager || ""}
                  ></input>
                  <input
                    type={"text"}
                    className="form-control wd-150"
                    placeholder="Project"
                    name="project"
                    onChange={handleChange}
                    value={filter.project || ""}
                  ></input>
                </div>
                <div>
                  <button type="button" className="btn btn-secondary" onClick={exportExcel}>
                    Export
                  </button>
                </div>
              </div>

              <div id="tableDetails" className="table-responsive">
                <table
                  border={1}
                  ref={tableDetails}
                  className="table table-sm table-bordered table-striped table-hover"
                >
                  <thead>
                    <tr>
                      <th rowSpan={2}>Employee Name</th>
                      <th rowSpan={2}>Emp ID</th>
                      <th rowSpan={2}>Manager</th>
                      <th rowSpan={2}>Project</th>
                      <th rowSpan={2}>Bill Rate</th>
                      <th rowSpan={2}>Start Date</th>
                      <th rowSpan={2}>End Date</th>
                      <th rowSpan={2}>Active (Y/N)</th>
                      {monthRange.map((val, index) => {
                        return (
                          <th key={val} colSpan={3} className="text-center">
                            {format(val, "MMM yyyy")}
                          </th>
                        );
                      })}
                    </tr>
                    <tr>
                      {monthRange.map((val, index) => {
                        return (
                          <>
                            <th key={generateKey("C" + format(val, "MM-yyyy"))} className="fs-1">
                              Claimed
                            </th>
                            <th key={generateKey("A" + format(val, "MM-yyyy"))} className="fs-1">
                              Approved
                            </th>
                            <th key={generateKey("Amt" + format(val, "MM-yyyy"))} className="fs-1">
                              Amount
                            </th>
                          </>
                        );
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {detailsData.map((emp, rowIndex) => {
                      return (
                        <tr key={emp.employeeId}>
                          <td>{emp.employeeName}</td>
                          <td>{emp.employeeId}</td>
                          <td>{emp.manager}</td>
                          <td>{emp.projectName}</td>
                          <td>{emp.billRate}</td>
                          <td>{format(parseISO(emp.billingStartDate), "dd/MM/yyyy")}</td>
                          <td>{format(parseISO(emp.billingEndDate), "dd/MM/yyyy")}</td>
                          <td>{emp.status === 1 ? "Y" : "N"}</td>
                          {monthRange.map((val, index) => {
                            return (
                              <>
                                <td
                                  key={emp["submittedHours" + format(val, "MM-yyyy") + rowIndex]}
                                  className="text-center" style={{color: "#999999"}}
                                >
                                  {emp["submittedHours" + format(val, "MM-yyyy")]}
                                </td>
                                <td
                                  key={emp["approvedHours" + format(val, "MM-yyyy") + rowIndex]}
                                  className="text-center"
                                >
                                  {emp["approvedHours" + format(val, "MM-yyyy")]}
                                </td>
                                <td
                                  key={emp["approvedHours" + format(val, "MM-yyyy") + rowIndex]}
                                  className="text-center"
                                >
                                  {(emp["approvedHours" + format(val, "MM-yyyy")] * emp.billRate) || ""}
                                </td>
                              </>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Reports;
